module.exports = __webpack_public_path__ + "static/products-image-1a86a0debd8ee7933f1da86efa2c2e9f.svg";